import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import NavbarAcccountContext from './NavbarAccountContext';
const DISPLAY_NAME = 'NavbarAcccountProvider';
const NavbarAccountProvider = _ref => {
  let {
    avatarSrc,
    userName,
    accountName,
    children
  } = _ref;
  const value = useMemo(() => ({
    avatarSrc,
    userName,
    accountName
  }), [avatarSrc, userName, accountName]);
  return /*#__PURE__*/React.createElement(NavbarAcccountContext.Provider, {
    value: value
  }, children);
};
NavbarAccountProvider.displayName = DISPLAY_NAME;
process.env.NODE_ENV !== "production" ? NavbarAccountProvider.propTypes = {
  /**
   * Sets children.
   */
  children: PropTypes.node,
  /**
   * Sets image source.
   */
  avatarSrc: PropTypes.string,
  /**
   * Sets the user name.
   */
  userName: PropTypes.string,
  /**
   * Sets the account name.
   */
  accountName: PropTypes.string
} : void 0;
export default NavbarAccountProvider;